'use es6';

export const HUBDB_SOURCE_TYPE = 1;
export const CRM_SOURCE_TYPE = 2;